/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field } from "formik";
import React, { ChangeEvent, useEffect, useState } from "react";
import { AddProductPropsType } from "../../../../constants/interface";
import { optionValues } from "../../../../shared/utility";
import Select from "react-select";
import ToggleInput from "../../../common/component/ToggleInput";
import infoCircle from "../../../../assets/info-circle-dark-fill.svg";
import arrowRight from "../../../../assets/arrow-right-icon-white.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getCategory,
  getSubCategory,
} from "../../../../store/actions/category";
import { getLocation } from "../../../../store/actions/location";
import ButtonLoader from "../../../common/component/ButtonLoader";
import { categoriesPaging } from "../../../../constants/constants";
import { useTranslation } from "react-i18next";

const ProductForm: React.FC<AddProductPropsType> = (props) => {
  const { values, errors, setFieldValue } = props;
  const dispatch: any = useDispatch();
  const {t} = useTranslation();

  const { categories, subcategories, locations, loading } = useSelector(
    (state: any) => ({
      categories: state?.category?.categories,
      subcategories: state?.category?.subcategories,
      locations: state?.locations?.locations,
      loading: state.product.loading,
    })
  );

  const [categoriesOptions, setCategoriesOptions] = useState<any>();
  const [subCategoriesOptions, setSubCategoriesOptions] = useState<any>();
  const [locationOptions, setLocationOptions] = useState<any>();

  // Get Categories
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    dispatch(getCategory( {data: categoriesPaging, signal, t} ));

    return () => {
      controller.abort();
    };
  }, []);

  // Get Locations
  useEffect(() => {
    const REQ = {
      pageSize: 50,
      start: 0,
    };
    dispatch(getLocation(REQ));
  }, []);

  // Format Locations for select options
  useEffect(() => {
    if (locations) {
      let locArr = optionValues(
        locations.items.map((e: any) => ({ id: e.id, name: e.name })),
        true
      );
      setLocationOptions(locArr);
    }
  }, [locations]);

  // Format Categories for select options
  useEffect(() => {
    if (categories && categories?.items) {

      const options = categories?.items;
      options.shift();

      setCategoriesOptions(options);
    }
  }, [categories]);

  // Get SubCategories
  useEffect(() => {
    if (values.category.value > 0) {
      dispatch(getSubCategory({ categoryId: values.category.value, ...categoriesPaging }));
    }
  }, [values.category]);

  // Format SubCategories for select options
  useEffect(() => {

    if (subcategories && subcategories.items) {
      setSubCategoriesOptions(subcategories.items);
    }
  }, [subcategories]);

  const handlePushNotificationToggle = (
    event: ChangeEvent<HTMLButtonElement>,
    setValues: any,
    value: boolean
  ) => {
    setValues("negotiable", !value);
  };

  const handleCategoryChange = (category: any, currentCategory: any) => {
    if(category?.value !== currentCategory?.value){
      setFieldValue("subCategory", {});
      setSubCategoriesOptions([]);

      setFieldValue("category", category);
    }   
  };

  return (
    <div className="flex flex-col gap-4 flex-grow pb-10">
      {/* product name */}
      <div className="flex flex-col gap-1">
        <label
          className="text-sm text-black-1E font-medium border-spacing-0"
          htmlFor="productName"
        >
          {t('add_edit_product_4')}
        </label>
        <Field
          className="w-full py-2 px-[14px] border-grey-EF border-[1px] rounded-lg text-grey-75"
          placeholder={t('add_edit_product_5')}
          type="text"
          name="productName"
          id="productName"
          value={values.productName}
          errors={errors.productName}
        />
        <ErrorMessage
          name="productName"
          component="p"
          className="text-[#ff0000] text-sm mt-1"
        />
      </div>
      {/* description */}
      <div className="flex flex-col gap-1">
        <label
          className="text-sm text-black-1E font-medium border-spacing-0"
          htmlFor="description"
        >
          {t('add_edit_product_6')}
        </label>
        <Field
          className="w-full py-2 px-[14px] border-grey-EF border-[1px] rounded-lg text-grey-75"
          as="textarea"
          placeholder={t('add_edit_product_7')}
          type="text"
          name="description"
          id="description"
          value={values.description}
          errors={errors.description}
        />
        <ErrorMessage
          name="description"
          component="p"
          className="text-[#ff0000] text-sm mt-1"
        />
      </div>
      {/* category and sub category  */}
      <div className="flex flex-col sm:flex-row gap-5">
        <div className="flex flex-1 flex-col gap-2">
          <label
            className="text-sm text-black-1E font-medium"
            htmlFor="category"
          >
            {t('add_edit_product_8')}
          </label>
          <Select
            options={categoriesOptions}
            placeholder={t('add_edit_product_10')}
            styles={customStyles}
            components={{ IndicatorSeparator }}
            onChange={(category: any) => handleCategoryChange(category, values?.category)}
            value={values?.category}
          />
          <ErrorMessage
            name="category"
            component="p"
            className="text-[#ff0000] text-sm mt-1"
          />
        </div>
        <div className="flex flex-1 flex-col gap-2 mb-1">
          <label
            className="text-sm text-black-1E font-medium"
            htmlFor="subCategory"
          >
            {t('add_edit_product_9')}
          </label>
          <Select
            options={subCategoriesOptions}
            placeholder={t('add_edit_product_11')}
            styles={customStyles}
            components={{ IndicatorSeparator }}
            onChange={(subCategory: any) => {
              // add api call to change language
              setFieldValue("subCategory", subCategory);
            }}
            value={values?.subCategory}
          />
          <ErrorMessage
            name="subCategory"
            component="p"
            className="text-[#ff0000] text-sm mt-1"
          />
        </div>
      </div>
      {/* price */}
      <div className="flex flex-col gap-1">
        <label
          className="text-sm text-black-1E font-medium border-spacing-0"
          htmlFor="price"
        >
          {t('add_edit_product_12')}
        </label>
        <Field
          className="w-full py-2 px-[14px] border-grey-EF border-[1px] rounded-lg text-grey-75"
          placeholder={t('add_edit_product_35')}
          type="number"
          name="price"
          id="price"
          value={values.price}
          errors={errors.price}
        />
        <ErrorMessage
          name="price"
          component="p"
          className="text-[#ff0000] text-sm mt-1"
        />
      </div>
      {/* location */}
      <div className="flex flex-col gap-1">
        <label
          className="text-sm text-black-1E font-medium border-spacing-0"
          htmlFor="location"
        >
          {t('add_edit_product_13')}
        </label>
        <div className="relative">
          <Select
            options={locationOptions}
            placeholder={t('add_edit_product_13')}
            styles={customStyles}
            components={{ IndicatorSeparator }}
            onChange={(location: any) => {
              setFieldValue("location", location);
            }}
            value={values.location}
          />
        </div>
        <ErrorMessage
          name="location"
          component="p"
          className="text-[#ff0000] text-sm mt-1"
        />
      </div>
      {/* Negotiable price */}
      <div className="flex flex-col gap-1 ">
        <div className="flex gap-1 items-center justify-between">
          <p className="text-base sm:text-xl font-medium">{t('add_edit_product_15')}</p>
          <ToggleInput
            isChecked={values.negotiable}
            handleToggle={(event) =>
              handlePushNotificationToggle(
                event,
                setFieldValue,
                values.negotiable
              )
            }
          />
        </div>
        <div className="flex items-center ">
          <img src={infoCircle} alt="info" className="w-4" />
          <p className="text-xs sm:text-sm text-grey-9E font-450">
          {t('add_edit_product_16')}
          </p>
        </div>
      </div>
      {/* action buttons */} {/* disable and set opacity based on form data */}
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          disabled={loading}
          className={`flex items-center justify-center sm:justify-normal gap-2 text-base py-3 px-10 bg-main text-white rounded-3xl whitespace-nowrap ${
            loading ? "opacity-40" : "opacity-100"
          }`}
          type="submit"
          onClick={() => {
            values.buttonName = "publishButton";
          }}
        >
          {loading && <ButtonLoader />}
          {t('add_edit_product_17')}
          <img src={arrowRight} alt="msg" />
        </button>
        <button
          disabled={loading}
          className={`flex items-center justify-center sm:justify-normal gap-2 font-medium py-3 px-10 bg-white text-main border-[2px] border-main rounded-3xl ${
            loading ? "opacity-40" : "opacity-100"
          }`}
          type="submit"
          onClick={() => {
            values.buttonName = "previewButton";
          }}
        >
          {t('add_edit_product_18')}
        </button>
      </div>
    </div>
  );
};

const IndicatorSeparator = () => {
  return null;
};

const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    border: "1px solid #EFEFEF",
    borderRadius: "8px",
    padding: "4px",
  }),
};

export default ProductForm;
